<div class="dialog-container" [ngSwitch]="data.type">
  <!-- SECRET -->
  <ng-container *ngSwitchCase="'secret'">
    <xten-input-text
      [label]="data.title"
      [type]="'password'"
      [readonly]="true"
      [showTogglePassword]="true"
      [showCopy]="true"
      [widthPx]="360"
      [ngModel]="data.secretValue ?? ''"
    ></xten-input-text>

    <div class="action">
      <button mat-raised-button class="btn-primary" (click)="close()">
        {{ "view_value.close" | translate }}
      </button>
    </div>
  </ng-container>

  <ng-container *ngSwitchDefault>
    <div class="icon-wrapper">
      <mat-icon class="dialog-icon" [ngStyle]="{ color: iconColor }">
        {{ icon }}
      </mat-icon>
    </div>

    <div class="content">
      <div class="title">{{ data.title | translate }}</div>
      <div class="message" *ngIf="data.message">
        {{ data.message | translate }}
      </div>
    </div>

    <div class="action">
      <button mat-stroked-button class="btn-primary" (click)="close()">
        {{ "view_value.close" | translate }}
      </button>
    </div>
  </ng-container>
</div>
